import { Prisma } from "../../../";
import { variantTypeIncludeStatement, variantTypeOrderByStatement } from "./variant";

export const cardTypeIncludeStatement = Prisma.validator<Prisma.CardInclude>()({
  guardian: true,
  elements: true,
  variants: {
    orderBy: variantTypeOrderByStatement,
    include: variantTypeIncludeStatement,
  },
  reverse: {
    include: {
      guardian: true,
    },
  },
});
